import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import ModalAction from "~components/Modal/ModalAction";
import useButtonsConfig from "../hooks/useButtonsConfig";
import { useState } from "react";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import ModalResponse from "~components/Modal/ModalResponse";
import LoaderFull from "~components/Form/components/LoaderFull";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";

const PriceSearchButtons = ({ dados, setShowButton, isOnline, open, origem, cameFromVisitaView }) => {
  const { parameter: idCliente, number: pesquisaId } = useParams();

  const [showMessageModal, setShowMessageModal] = useState({
    text: "",
    type: "success",
  });
  const url = window.location.pathname;
  const regex = /^\/pesquisa-de-preco\/\d+\/nova-pesquisa$/;
  const { checkin } = useCheckIn();

  const { closeModal } = useModalResponse();

  const { buttonConfigs, setTipoMensagem, loadingVisita, loadingPost } = useButtonsConfig({
    dados,
    setShowButton,
    idCliente,
    isOnline,
    setShowMessageModal,
    open,
    origem,
    cameFromVisitaView,
  });

  return (
    <div className="grid gap-x-4 container grid-cols-1 xs:grid-cols-2" data-testid="price-search-buttons">
      {((!dados?.fechado && dados?.consomeBasico) || (pesquisaId && !(!dados?.fechado || dados?.consomeBasico))) && (
        <>
          <button
            key={0}
            className="bg-primaria text-center text-white px-5 py-6 rounded-lg w-[100%] font-bold mt-4 priceButtonModal"
            data-testid="sinalizar-cliente-fechado"
            onClick={() => {
              setTipoMensagem("alterar-fechado");
              buttonConfigs.fechado.open();
            }}
          >
            {buttonConfigs.fechado.buttonLabel}
          </button>
          <button
            key={1}
            className="bg-primaria text-center text-white px-5 py-6 rounded-lg w-[100%] font-bold mt-4 priceButtonModal"
            data-testid="cliente-nao-consome-basicos"
            onClick={() => {
              setTipoMensagem("alterar-consome-basico");
              buttonConfigs.naoConsome.open();
            }}
          >
            {buttonConfigs.naoConsome.buttonLabel}
          </button>
        </>
      )}

      {loadingPost && (
        <div className="spinner__form">
          <LoaderFull />
        </div>
      )}
      {loadingVisita && regex.test(url) && +idCliente === checkin?.clienteId && (
        <div className="spinner__form">
          <LoaderFull />
        </div>
      )}

      {showMessageModal.text ? (
        <ModalResponse
          isOpen={true}
          closeModal={() => {
            const onClose = showMessageModal.onClose;
            setShowMessageModal((prev) => ({
              ...prev,
              text: "",
              onClose: () => {},
            }));

            closeModal();

            if (onClose && typeof onClose == "function") onClose();
          }}
          status={showMessageModal.type}
          message={showMessageModal.text}
          submessage={showMessageModal.submessage ?? ""}
          button="Ok"
        />
      ) : null}

      <ModalAction
        isOpen={buttonConfigs.fechado.isModal}
        onClose={() => (dados?.fechado ? buttonConfigs.fechado.redirectTo() : buttonConfigs.fechado.closeModal())}
        title="Aviso!"
        sub={buttonConfigs.fechado.sub}
        buttonOne="Sim"
        buttonTwo="Não"
        linkOne={buttonConfigs.fechado.action()}
        linkTwo={() => (dados?.fechado ? buttonConfigs.fechado.redirectTo() : buttonConfigs.fechado.closeModal())}
      />
      <ModalAction
        isOpen={buttonConfigs.naoConsome.isModal}
        onClose={() =>
          !dados?.consomeBasico ? buttonConfigs.naoConsome.redirectTo() : buttonConfigs.naoConsome.closeModal()
        }
        title="Aviso!"
        sub={buttonConfigs.naoConsome.sub}
        buttonOne="Sim"
        buttonTwo="Não"
        linkOne={buttonConfigs.naoConsome.action()}
        linkTwo={() =>
          !dados?.consomeBasico ? buttonConfigs.naoConsome.redirectTo() : buttonConfigs.naoConsome.closeModal()
        }
      />
    </div>
  );
};

PriceSearchButtons.propTypes = {
  dados: PropTypes.shape({
    fechado: PropTypes.bool,
    consomeBasico: PropTypes.bool,
  }),
  setShowButton: PropTypes.func.isRequired,
  isOnline: PropTypes.bool.isRequired,
  open: PropTypes.bool,
  origem: PropTypes.string,
  cameFromVisitaView: PropTypes.string,
};

PriceSearchButtons.defaultProps = {
  dados: {
    fechado: false,
    consomeBasico: false,
  },
  open: false,
};

export default PriceSearchButtons;
